import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDirectDependency = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 15,
	height: 15,
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_111392_2342)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M13.5109 8.80553H11.9402V6.69443C11.9402 6.63331 11.8859 6.58331 11.8194 6.58331H8.07401V5.24998H9.70508C9.83798 5.24998 9.94672 5.14998 9.94672 5.02776V1.02776C9.94672 0.905542 9.83798 0.805542 9.70508 0.805542H5.35557C5.22267 0.805542 5.11393 0.905542 5.11393 1.02776V5.02776C5.11393 5.14998 5.22267 5.24998 5.35557 5.24998H6.98663V6.58331H3.24122C3.17477 6.58331 3.1204 6.63331 3.1204 6.69443V8.80553H1.54975C1.41684 8.80553 1.30811 8.90553 1.30811 9.02776V13.0278C1.30811 13.15 1.41684 13.25 1.54975 13.25H5.89926C6.03216 13.25 6.1409 13.15 6.1409 13.0278V9.02776C6.1409 8.90553 6.03216 8.80553 5.89926 8.80553H4.20778V7.58331H10.8529V8.80553H9.16139C9.02849 8.80553 8.91975 8.90553 8.91975 9.02776V13.0278C8.91975 13.15 9.02849 13.25 9.16139 13.25H13.5109C13.6438 13.25 13.7525 13.15 13.7525 13.0278V9.02776C13.7525 8.90553 13.6438 8.80553 13.5109 8.80553ZM4.99311 9.86109V12.1944H2.45589V9.86109H4.99311ZM12.6048 12.1944H10.0675V9.86109H12.6048V12.1944Z",
				fill: "currentColor"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_111392_2342",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 14,
				height: 14,
				fill: "white",
				transform: "translate(0.530273 0.027771)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgDirectDependency);
export { ForwardRef as ReactComponent };
